import React, { useState, useEffect, useRef } from 'react';

const EosLogo = ({ className = '', customLogoUrl = null }) => {
  const [imageError, setImageError] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });
  const containerRef = useRef(null);
  
  const handleImageError = () => {
    setImageError(true);
    setImageLoaded(true); // Consider it "loaded" even if it errors, so we show default
  };
  
  const handleImageLoad = (e) => {
    setImageLoaded(true);
    setImageDimensions({
      width: e.target.naturalWidth,
      height: e.target.naturalHeight
    });
  };
  
  // Preload the custom image to get dimensions
  useEffect(() => {
    if (customLogoUrl && !imageError) {
      const img = new Image();
      img.onload = () => {
        setImageDimensions({
          width: img.naturalWidth,
          height: img.naturalHeight
        });
      };
      img.onerror = () => {
        setImageError(true);
      };
      img.src = customLogoUrl;
    }
  }, [customLogoUrl, imageError]);
  
  const logoSrc = !imageError && customLogoUrl ? customLogoUrl : "/images/eos-logo.png";
  
  return (
    <div ref={containerRef} className={`flex items-center justify-center p-1 ${className}`}>
      <img 
        src={logoSrc}
        alt="EOS Worldwide Logo" 
        className="h-auto w-auto max-w-full max-h-full object-contain"
        style={{ maxHeight: '100%', maxWidth: '100%' }}
        onError={handleImageError}
        onLoad={handleImageLoad}
      />
    </div>
  );
};

export default EosLogo;
